import { TextareaProps } from "@ttc3k/trekker";
import { useEffect, useRef } from "react";
import { styled } from "styled-system/jsx";

type AutogrowTextareaProps = {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  props: TextareaProps;
};

/**
 * This component is used to create a textarea that automatically grows to fit the content.
 * It is used in the ScratchPad component to allow the user to edit their scratchpad.
 * @returns
 */
export const AutogrowTextarea = ({
  value,
  onChange,
  props,
}: AutogrowTextareaProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  // When the value changes, we need to update the height of the textarea to fit the content
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [value]);

  return (
    <styled.textarea
      ref={textareaRef}
      autoFocus
      value={value}
      onChange={onChange}
      overflow="hidden"
      resize="none"
      display="block"
      {...props}
    />
  );
};
